var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: "/static/icon-success.svg" } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Sua solicitação foi enviada!")]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("p", [
          _vm._v(
            "\n      Nosso time de experiência recebeu sua solicitação e vai cuidar com muito carinho 💜\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _c("b", [
            _vm._v(
              "Responderemos assim que possível, então fique atento aos seus emails!"
            )
          ]),
          _c("br"),
          _vm._v("\n      Você irá receber nossa comunicação por lá."),
          _c("br"),
          _c("br"),
          _vm._v(
            "\n      Não esqueça de verificar a sua caixa de spam 😉\n    "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4e18a3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4e18a3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Cancellation/Success.vue
// module id = null
// module chunks = 